import FlexBetweenItem from '../../../common/layout/FlexBetweenItem';
import RadioButtonV2 from '../../../common/RadioButtonV2';
import { AppText, AppTitle } from '../../../common/typography/app-text';
import VerticalStack from '../../../common/wrapper/VerticalStack';
import classes from './TreatmentItem.module.scss';
import { ReactComponent as StarIcon } from '../../../../images/icons/bl-star-icon.svg';
import { ReactComponent as PriceIcon } from '../../../../images/icons/bl-price-icon.svg';
import { ReactComponent as TimeIcon } from '../../../../images/icons/bl-time-icon.svg';
import { pounds } from '../../../../utils/general';
import classNames from 'classnames';
import { useId } from 'react';
import Skeleton from 'react-loading-skeleton';
import { APP_COMPONENT_SIZE } from '../../../../utils/constants';
import { formatTime } from '../helper';

export const TreatmentItemSkeleton = () => {
    return (
        <div className={classes.treatmentItem}>
            <FlexBetweenItem center>
                <div className={classes.treatmentDetails}>
                    <Skeleton width={47} height={47} borderRadius={8} />
                    <VerticalStack space={5}>
                        <Skeleton height={20} width={180} />
                        <Skeleton height={17} width={230} />
                    </VerticalStack>
                </div>
                <div className={classes.treatmentDescription}>
                    <Skeleton height={24} width={24} circle />
                </div>
            </FlexBetweenItem>
        </div>
    );
};

function TreatmentItem({
    image,
    title,
    price,
    rating,
    reviewCount,
    duration,
    isChecked,
    onChange,
    onOpenTreatmentDetails,
    treatmentId,
}) {
    const id = useId();
    return (
        <div
            onClick={(e) => {
                if (e.target.id === id) {
                    return;
                }
                onOpenTreatmentDetails();
            }}
            data-treatment-id={treatmentId}
            className={classNames(classes.treatmentItem, isChecked && classes.treatmentItemChecked)}
        >
            <FlexBetweenItem center>
                <div className={classes.treatmentDetails}>
                    <div className={classes.treatmentImage}>
                        <img src={image} alt="treatment" />
                    </div>
                    <VerticalStack space={5}>
                        <AppTitle>{title}</AppTitle>
                        <div className={classes.treatmentDescription}>
                            <div className={classes.treatmentListItem}>
                                <PriceIcon className={classes.treatmentIcon} />
                                <AppText className={classes.treatmentDescriptionText} dark>
                                    {pounds.format(price)}
                                </AppText>
                            </div>
                            <div
                                // style={{ alignItems: 'flex-end' }}
                                className={classes.treatmentListItem}
                            >
                                <StarIcon className={classes.treatmentIcon} />
                                <AppText className={classes.treatmentDescriptionText} dark>
                                    {rating} ({reviewCount})
                                </AppText>
                            </div>
                            <div className={classes.treatmentListItem}>
                                <TimeIcon className={classes.treatmentIcon} />
                                <AppText className={classes.treatmentDescriptionText} dark>
                                    {formatTime(duration)}
                                </AppText>
                            </div>
                        </div>
                    </VerticalStack>
                </div>
                <RadioButtonV2
                    size={APP_COMPONENT_SIZE.large}
                    className={classes.treatmentRadioButton}
                    checked={isChecked}
                    onClick={onChange}
                    id={id}
                />
            </FlexBetweenItem>
        </div>
    );
}
export default TreatmentItem;
